import type { ProjectSchema } from "@/features/Projects/models/project.types";

interface SchemaOverviewProps {
  schema: ProjectSchema | null | undefined;
}

export function SchemaOverview({ schema }: SchemaOverviewProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h3 className="text-lg font-medium text-gray-900">Schema Técnico</h3>
        <p className="text-sm text-gray-600">
          Modelos de dados, APIs e documentação do projeto
        </p>
      </div>

      {schema && (
        <div className="flex space-x-4">
          <div className="text-center">
            <div className="text-2xl font-bold text-cyan-600">
              {schema.stats.totalModels}
            </div>
            <div className="text-xs text-gray-500">Modelos</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-cyan-600">
              {schema.stats.totalEndpoints}
            </div>
            <div className="text-xs text-gray-500">Endpoints</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-cyan-600">
              {schema.stats.totalFields}
            </div>
            <div className="text-xs text-gray-500">Campos</div>
          </div>
        </div>
      )}
    </div>
  );
}